import React, {useState} from "react";
import './AddPracujeJako.css';
import {db} from './firebase';
// import firebase from 'firebase';
import firebase from './firebase';
import { useForm } from 'react-hook-form';
import {addActor} from './features/addedActorsSlice';
import { useDispatch } from 'react-redux';

function AddActor() {
const dispatch = useDispatch();
const { handleSubmit, register } = useForm();

const onSubmit = (formData) => {
  db.collection('addedActors').add(
      {
          name: formData.actor,
          type: "actor",
          timestamp: firebase.firestore.FieldValue.serverTimestamp()
      });

      dispatch(addActor({
        name: formData.actor
      })
      )
      document.getElementById("my-form").value='';
};

    return (
        <form onSubmit={handleSubmit(onSubmit)} className="add-co-sie-stalo">

          <span className="pin">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M11 17h2v5l-2 2v-7zm3.571-12c0-2.903 2.36-3.089 2.429-5h-10c.068 1.911 2.429 2.097 2.429 5 0 3.771-3.429 3.291-3.429 10h12c0-6.709-3.429-6.229-3.429-10z"/></svg>
          </span>
          <input 
          id="my-form"
          name='actor' 
          type="text" 
          placeholder="Dodaj aktora" 
          className="no-background"
          ref={register( {required: true})}
          />
          <button type="submit">Send</button>

        </form>
    );
  
}

export default AddActor;
